import { ThemedFixedButton } from "@/Button";
import { Header } from "@/Header";
import { SequentialAnimation } from "@/SequentialAnimation";
import { useAppColor } from "^/common/useAppColor";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useForm } from "react-hook-form";
import { SignUpBusinessState } from "./business-owner";
import { useContext } from "react";
import { SignupContext } from "@/SignupContext";

export const Route = createFileRoute("/sign-up/business-teacher-done")({
  component: RouteComponent,
});

export interface SignUpBusinessDetailState extends SignUpBusinessState {
  agree3: boolean;
  storeTelNumber: string;
}

function RouteComponent() {
  // const [cookie] = useCookies(["email"]);
  const { getInfo, setInfo } = useContext(SignupContext);
  // const email: string = useMemo(() => cookie.email, [cookie]);
  const { history } = useRouter();
  const {
    handleSubmit,

    // setValue,
    formState: { isValid },
  } = useForm<SignUpBusinessDetailState>({
    defaultValues: {
      email: getInfo()?.email,
      storeName: getInfo()?.storeName,
      storeNumber: getInfo()?.storeNumber,
      businessLicense: getInfo()?.businessLicense,
      name: getInfo()?.name,
      phone: getInfo()?.phone,
    },
  });
  // const allCheck = watch("agree1") && watch("agree2");
  // const handleAllCheck = () => {
  //   if (isSubmitted || !allCheck) {
  //     setValue("agree1", !allCheck, { shouldValidate: true });
  //     setValue("agree2", !allCheck, { shouldValidate: true });
  //   } else {
  //     setValue("agree1", !allCheck);
  //     setValue("agree2", !allCheck);
  //   }
  // };

  const bindSubmit = (data: SignUpBusinessDetailState) => {
    setInfo(data);
    history.push("/business/layout/teacher");
  };

  useAppColor({
    background: "#ff9934",
  });

  return (
    <div className="flex flex-col flex-auto">
      <Header title="가입완료" className="text-white border-0 bg-yellow" />
      <SequentialAnimation>
        <div className="bg-white flex flex-col flex-auto rounded-t-3xl py-10 px-5 gap-4 min-h-[calc(100vh-100px)]">
          {/* 가입정보 확인 */}
          <div className="text-sm font-medium">가입정보 확인</div>
          <div className="p-4 mb-6 bg-white rounded-xl shadow">
            <div className="grid grid-cols-3 gap-y-3">
              <div className="col-span-1 font-medium text-gray">이름</div>
              <div className="col-span-2 font-medium">{getInfo()?.name}</div>
              <div className="col-span-1 font-semibold text-gray">
                휴대폰 번호
              </div>
              <div className="col-span-2 font-medium">{getInfo()?.phone}</div>
              <div className="col-span-1 font-semibold text-gray">
                이메일 주소
              </div>
              <div className="col-span-2 font-medium">{getInfo()?.email}</div>
            </div>
          </div>
        </div>
      </SequentialAnimation>

      <ThemedFixedButton
        disabled={!isValid}
        onClick={handleSubmit(bindSubmit)}
        color="primary"
        size="md"
      >
        가입 완료
      </ThemedFixedButton>
    </div>
  );
}
